import React from "react";
import "../../styles/CaseStudyFour/CaseStudiesHero4.css";

const CaseStudiesHero4 = () => {
  return (
    <section id="case-studies-hero-four" className="case-studies-hero4">
      <div className="hero-container4">
        {/* Left Content */}
        <div className="hero-left4">
          <h2 className="hero-subtitle4">End-To-End Tracking</h2>
          <h1 className="hero-title4">Hello Hello</h1>
          <p className="hero-description4">
          John Volken Academy Movers is a top-rated moving company serving Phoenix, AZ and Kent, WA, known for their professional, reliable, and affordable moving services.
           As a 5-star rated mover, they deliver exceptional customer satisfaction while supporting a greater cause helping individuals 
           transform their lives through the John Volken Academy.
          </p>
          <ul className="hero-kpi-list4">
            <li className="kpi-item4">
              <div className="case-study-checkmark-icon4"></div> Cost Per Move: Decreased from $384 to $149
            </li>
            <li className="kpi-item4">
              <div className="case-study-checkmark-icon4"></div> Total Moves Generated: 64
            </li>
            <li className="kpi-item4">
              <div className="case-study-checkmark-icon4"></div> Increased ROAS from 2.5 to 6.4
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="hero-right4">
          <div className="hero-image-container4">
            <img
              src={require("../../assets/john-volken-logo.png")} // Replace with your image path
              alt="Bullfrog Logo"
              className="hero-image4"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesHero4;
